export const CONTENT_UPDATES = "content-updates";

export function isContentUpdate(entry) {
    return entry.componentKind === "ARTIFACT_COMPONENT_KIND_WASM";
}

export function isBundledWatchdog(entry) {
    return entry.componentKey === "agent:watchdog";
}

export function commonValue(values) {
    return values.length && values.every((value) => value === values[0]) ? values[0] : "";
}

export function groupContentConfigurations(configurations) {
    const visible = configurations.filter((entry) => !isBundledWatchdog(entry));
    const members = visible.filter(isContentUpdate);
    if (!members.length) return visible;
    const schedule = commonValue(members.map((entry) => JSON.stringify(entry.waveSteps ?? [])));
    return [
        ...visible.filter((entry) => !isContentUpdate(entry)),
        {
            componentId: CONTENT_UPDATES,
            componentKey: CONTENT_UPDATES,
            displayName: "Content updates",
            environment: commonValue(members.map((entry) => entry.environment)),
            members,
            mixedWaveSteps: schedule === "",
            waveScope: commonValue(members.map((entry) => entry.waveScope)),
            waveSteps: schedule ? JSON.parse(schedule) : [],
        },
    ];
}
